import { TrackingForm } from '../components/tracking/TrackingForm'
import { siteConfig } from '../config/site'

const description = 'Track FedEx, USPS, DHL, or UPS shipments through the carrier’s official tracking website.'

export function TrackingPage() {
  return (
    <article className="content-page tracking-page">
      <title>Package Tracking | Pack Print Mail</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`${siteConfig.siteUrl}/Tracking`} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteConfig.displayName} />
      <meta property="og:title" content="Package Tracking | Pack Print Mail" />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${siteConfig.siteUrl}/Tracking`} />

      <header className="legacy-page-title">
        <div className="inner-shell">
          <p>Track your shipment</p>
          <h1>Package Tracking</h1>
        </div>
      </header>

      <div className="inner-shell content-page__body tracking-page__body">
        <section className="tracking-page__panel" aria-labelledby="tracking-page-heading">
          <div className="tracking-page__icon" aria-hidden="true">▣</div>
          <div>
            <h2 id="tracking-page-heading">Enter your tracking number</h2>
            <p>
              We will identify the carrier when the number format is distinctive. If it is not,
              choose the carrier shown on your receipt or label.
            </p>
            <TrackingForm idPrefix="tracking-page" variant="page" />
          </div>
        </section>

        <p className="tracking-page__notice">
          Pack Print Mail does not provide shipment status on this page. Tracking results and
          delivery information come directly from the carrier’s official website.
        </p>
      </div>
    </article>
  )
}
